module.exports = __webpack_public_path__ + "img/project-play.c9607a11.svg";